import * as core from '../../../../../../../core'

import { query } from './requirements-dashboard-type-bar.query'

export const RESOURCE = {
  payload: {
    alias: 'requirements-dashboard.type-bar',
    description:
      'Requirement count per requirement type, click a bar to filter the table below',
    name: 'Requirements Dashboard - Type Bar',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
